module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAHCAMAAACLH2sFAAAALHRFWHRDcmVhdGlvbiBUaW1lAFRodSAyNyBNYXIgMjAwOCAwMzo0MDoxNyAtMDUwMLm0WfoAAAAHdElNRQfYBBoWJAgfBZOPAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAACRQTFRF////qqShxM3R3drXvLu4w7+5s6+pvLu5zMjBw8TBzMfB0M3HAgaZwgAAAAF0Uk5TAEDm2GYAAAA6SURBVHjaY2CAAkYmZmYmFgY0gF2UgZWNjRVDkCQjONm4uNlYKDICh9sGsxHsbBwcbJQZgT3sUdUCAGGeAYGTRrHZAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/slider/slider-v-bg.png
 ** module id = 503
 ** module chunks = 0
 **/